import TagCardsContainer from "../../../../Component/Application/Tags/TagCards/TagCards";

const TagCards = () => {
  return (
    <div className="page-body">
      <TagCardsContainer />
    </div>
  );
};

export default TagCards;
